export const WIDGET_ID = "result-reputation-sentiment";
